import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import { Box, styled } from '@mui/material';
import { $getRoot } from 'lexical';

import { InitialConfigType, LexicalComposer } from '@lexical/react/LexicalComposer';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import { ListPlugin } from '@lexical/react/LexicalListPlugin';
import { HistoryPlugin } from '@lexical/react/LexicalHistoryPlugin';
import LexicalErrorBoundary from "@lexical/react/LexicalErrorBoundary";
import TextToolbar from './TextToolbar';
import { OnChangePlugin } from '@lexical/react/LexicalOnChangePlugin';
import { EditordNodes, lexicalEditorTheme } from '../../helpers/editor.helper';
import { $createParagraphNode } from 'lexical';
import TextEditorOptions from './TextEditorOptions';
import { useContext, useLayoutEffect, useState } from 'react';
import { AppContext } from '../../context';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

interface TextEditorProps {
    onAccept: (data: string) => void,
    onCancel?: VoidFunction,
    previousContent: string
}

const MuiContentEditable = styled(ContentEditable)({
    minHeight: 100,
    width: "100%",
    padding: "0 8px",
    borderRadius: 5,
    paddingTop: 2,
    paddingLeft: 4,
    position: "relative",
    outline: "none",
});

const placeHolderSx = {
    position: "absolute",
    top: 15,
    left: 4,
    userSelect: "none",
    display: "inline-block",
    pointerEvents: "none",
    color: '#aaa',
    fontSize: '1.25rem'
};


function onError(error: any) {
    throw error;
}

const initialConfig: InitialConfigType = {
    namespace: 'MyEditor',
    theme: lexicalEditorTheme,
    nodes: [...EditordNodes],
    editorState: () => {
        const root = $getRoot();
        if (root.isEmpty()) {
            const paragraph = $createParagraphNode();
            root.append(paragraph);
        }
    },
    onError,
}

export default function TextEditor({ onAccept, onCancel, previousContent }: TextEditorProps) {
    const appContext = useContext(AppContext)
    const [text, setText] = useState<string | null>(null)
    const AutofocusPlugin = () => {
        const [editor] = useLexicalComposerContext();

        useLayoutEffect(() => {
            editor.focus();
        }, [editor]);

        return null;
    };

    function onChange(editorState: any) {
        editorState.read(() => {
            const root = $getRoot();
            setText(root.__cachedText)
        });
    }
    return (
        <div className='texteditor '>
            <LexicalComposer initialConfig={initialConfig}>
                <TextToolbar content={previousContent} />
                <Box className='texteditor-wrapper'>
                    <RichTextPlugin
                        contentEditable={<MuiContentEditable />}
                        placeholder={<Box sx={placeHolderSx}>Escriba aquí</Box>}
                        ErrorBoundary={LexicalErrorBoundary}
                    />
                    <OnChangePlugin onChange={onChange} />
                    <HistoryPlugin />
                    <ListPlugin />
                    <AutofocusPlugin />
                </Box>
                <TextEditorOptions onAccept={onAccept} onCancel={onCancel || console.log} processing={appContext?.loading} disabled={!text} />
            </LexicalComposer>
            {appContext?.loading && <div className='procesing'></div>}
        </div>
    )
}
